import { forwardRef } from 'react';

import { Box, useTheme, TextField, IconButton } from '@mui/material';

import { Iconify } from 'src/components/iconify';

type Props = {
  label: string;
  value: string;
  disabled: boolean;
  placeholder: string;
  onChange: (value: string) => void;
  onSearchClick: () => void;
  onAddClick?: () => void;
  isAddButton?: boolean;
  isAccountCreate?: boolean;
  error?: boolean;
  helperText?: string;
};

export const SearchInputField = forwardRef<HTMLDivElement, Props>(
  (
    {
      label,
      value,
      disabled,
      placeholder,
      onChange,
      onSearchClick,
      onAddClick,
      isAddButton = false,
      isAccountCreate = false,
      error,
      helperText,
    },
    ref
  ) => {
    const theme = useTheme();

    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <TextField
          fullWidth
          label={label}
          value={value}
          disabled={disabled}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          error={!!error}
          helperText={helperText}
          InputLabelProps={{ shrink: true }}
          ref={ref}
        />

        <IconButton
          aria-label="search"
          disabled={disabled}
          onClick={onSearchClick}
          sx={{
            backgroundColor: disabled
              ? theme.palette.action.disabledBackground
              : theme.palette.primary.main,
            color: theme.palette.common.white,
            '&:hover': {
              backgroundColor: !disabled
                ? theme.palette.primary.dark
                : theme.palette.action.disabledBackground,
            },
          }}
          disableRipple
        >
          <Iconify icon="eva:search-fill" />
        </IconButton>

        {isAddButton && (
          <IconButton
            aria-label="add"
            disabled={disabled || isAccountCreate}
            onClick={onAddClick}
            sx={{
              backgroundColor:
                disabled || isAccountCreate
                  ? theme.palette.action.disabledBackground
                  : theme.palette.primary.main,
              color: theme.palette.common.white,
              '&:hover': {
                backgroundColor:
                  !disabled && !isAccountCreate
                    ? theme.palette.primary.dark
                    : theme.palette.action.disabledBackground,
              },
            }}
            disableRipple
          >
            <Iconify icon="mingcute:add-line" />
          </IconButton>
        )}
      </Box>
    );
  }
);